import React, { useEffect, useState } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import {
  Items,
  Product,
  ProductRatingType,
  ProductMinMaxPriceType,
} from '../../types';
import ProductCard from './ProductCard';

interface useStaticQueryProps {
  products: Items<Product>;
}

interface Props {
  searchValue: string;
  products: Product[];
  pageContext: {
    productsRating: ProductRatingType;
    productsMinMaxPrice: ProductMinMaxPriceType;
  };
}

const ListProductSearch: React.FC<Props> = ({
  searchValue,
  products,
  pageContext,
}) => {
  const { productsRating, productsMinMaxPrice } = pageContext;

  const hasResult = !!products.length;

  const productsList = products.map((product) => (
    <div key={product.data.name}>
      <ProductCard
        product={product}
        rating={productsRating[product.data.name] ?? 0}
        pricingFrom={productsMinMaxPrice[product.data.name]?.min ?? 0}
      />
    </div>
  ));

  if (!hasResult) {
    return (
      <div className="pl-4">
        <h1 className="text-xl pb-3">No result for {searchValue}</h1>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="pl-4">
        <h1 className="text-xl pb-3">Result for {searchValue}</h1>
      </div>
      <div className="grid grid-flow-row grid-cols-1 gap-8 lg:grid-cols-3 sm:grid-cols-2">
        {productsList}
      </div>
    </React.Fragment>
  );
};

export default ListProductSearch;
